import React, { Component } from "react";
import Footer from "../components/Footer";
import Mainmenu from "../components/Mainmenu";
import Navbar from "../components/Navbar";
import SettingsSlideshowContent from "./SettingsSlideshowContent";

export default class SettingsSlideshow extends Component {
  render() {
    return (
      <div className="wrapper">
        <Navbar />
        <Mainmenu />
        <SettingsSlideshowContent />
        <Footer />
      </div>
    );
  }
}
